import texts from "../interfaceTexts";
//import getCookie from "./getCookie";

// get Language
//const cookieLang = getCookie('wp-wpml_current_language');
//const lang = !!cookieLang ? cookieLang.toLowerCase() : 'ru';
const lang = !!window.location.pathname.split('/')[1].length ? window.location.pathname.split('/')[1].toLowerCase() : 'ru';
const text = texts[lang];

export default text;
